import styled from 'styled-components';
import { spacing } from '@pb/styles';

export const StyledContainer = styled.div`
    display: inline-flex;
    flex-direction: column;
    width: 100%;
    margin: ${spacing(4, 0)};

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.s.min}) {
        flex-direction: row;
        max-width: 75%;
        gap: ${spacing(6)};
        margin-top: 0;
    }
`;

export const StyledPropertyImageContainer = styled.div`
    display: flex;
    width: 100vw;
    position: relative;
    left: calc(-50vw + 50%);

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.s.min}) {
        max-width: 50%;
        width: 100%;
        position: inherit;
    }
`;

export const StyledPropertyImage = styled.img`
    width: 100%;
    height: 100%;
`;

export const StyledPropertyDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;

    span {
        font-weight: ${({ theme }) => theme.font.weight.semiBold};
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.m.min}) {
        max-width: 50%;
        margin: ${spacing(2, 0, 4, 0)};
    }
`;
